<template>
  <div>
    <!-- 添加用户表对话框 -->
    <el-dialog
      title="查看用户积分记录"
      :visible.sync="addDialogVisible"
      width="60%"
      @close="addDialogClosed">
      <el-table :data="integralList" style="padding-top: 10px;" class="button-box">
        <el-table-column label="积分" prop="integral" />
        <el-table-column label="类型" prop="enumType">
          <template slot-scope="scope">
            {{scope.row.enumType | formatIntegralType}}
          </template>
        </el-table-column>
        <el-table-column label="说明" prop="brief" />
        <el-table-column label="发放时间" prop="createDatetime">
          <template slot-scope="scope">
            {{scope.row.createDatetime | formatDate}}
          </template>
        </el-table-column>

        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button @click="modifyIntegral(scope.row)">修改</el-button>
            <el-button @click="removeIntegral(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页区域 -->
      <paging :total="total"
              :page.sync="queryInfo.current"
              :limit.sync="queryInfo.size"
              @pagination="getIntegralList"></paging>
    </el-dialog>

    <el-dialog :visible.sync="modifyDialogVisible" width="30%">
      <el-form label-width="60px">
        <el-form-item label="备注">
          <el-input v-model="modifyForm.brief"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="modifyDialogVisible = false">取 消</el-button>
        <el-button @click="confirmModifyIntegral">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import { deleteIntegralsById, getIntegralsByUserId, postModifyIntegralsById } from '@/api/Integral/Integral'
import Paging from '@/components/common/paging/index'

export default {
  name: 'lookIntegrated',
  components: { Paging },
  data() {
    return {
      addForm: {}, //添加组织表单
      addDialogVisible: false,
      modifyDialogVisible: false,
      integralList: [],
      userId: '',
      total: 0,
      queryInfo: {
        current: 1,
        size: 10,
        keyword: ''
      },
      modifyForm: {}
    }
  },
  created() {

  },
  methods: {
    lookDialog(row) {
      this.userId = row.id
      this.getIntegralList()
      this.addDialogVisible = true
    },

    getIntegralList() {
      getIntegralsByUserId(this.queryInfo, this.userId).then(res => {
        this.integralList = res.code === '0' ? res.data.records : []
        this.total = res.data.total - 0
      })
    },

    //修改
    modifyIntegral(data) {
      this.modifyForm = JSON.parse(JSON.stringify(data))
      this.modifyDialogVisible = true

    },

    confirmModifyIntegral() {
      postModifyIntegralsById(this.modifyForm.id, this.modifyForm).then(res => {
        if (res.code === '0') {
          this.$message.success('执行成功');
          this.modifyDialogVisible = false
          this.getIntegralList()
        }
      })
    },

    //删除
    removeIntegral(data) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteIntegralsById(data.id).then(res => {
          if (res.code === '0') {
            this.$message.success('执行成功');
            this.getIntegralList()
          }
        })
      }).catch(() => {})
    },

    //关闭弹窗
    cancel() {
      this.addDialogVisible = false
      this.addForm = {}
    },

    addDialog() {
      this.addDialogVisible = true
    },

    // 监听添加用户对话框的关闭事件 /  重置表单
    addDialogClosed() {
      this.addForm = {}
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-input {
  width: 90%;
}

.button-box .el-button {
  margin-left: 10px;
  background-color: #fff;
  color: #666666;
  border-radius: 20px;
  padding: 4px 8px;
  border: 1px solid #d8e1f2;
}

.button-box .el-button:hover {
  background-color: #d8e1f2;
  color: #3150e9;
  border: 1px solid transparent;
  box-shadow: none;
}
</style>
